export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_3-9121426ba4c08177842ad84b7d33927a.jpg";